export default [
  {
    path: '/experiments/:id?',
    name: 'experiments',
    component: () => import('@/views/modules/skeleton/admin/Experiments/Experiments.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Experiments',
          active: true,
          redirectIfLoggedIn: true,
        },
      ],
    },
  },
  {
    path: '/add-experiment',
    name: 'add_experiment',
    component: () => import('@/views/modules/skeleton/admin/Experiments/CreateExperiment.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Add Experiment',
          back: true,
          active: true,
          redirectIfLoggedIn: true,
        },
      ],
    },
  },
  {
    path: '/edit-experiment/:id',
    name: 'edit_experiment',
    component: () => import('@/views/modules/skeleton/admin/Experiments/CreateExperiment.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Edit Experiment',
          back: true,
          active: true,
          redirectIfLoggedIn: true,
        },
      ],
    },
    // beforeEnter: (to, from, next) => {

    //   if (from.name) {
    //     to.meta.breadcrumb = [];
    //     to.meta.breadcrumb.push({
    //       text: 'Preview Experiments',
    //       href: from.path
    //     });
    //     to.meta.breadcrumb.push({
    //       text: 'Edit Experiment',
    //       active: true,
    //     });
    //   }
    //   else{
    //     to.meta.breadcrumb = [];
    //     to.meta.breadcrumb.push(
    //       {
    //         text: 'Experiments',
    //         to: '/experiments'
    //       },
    //       {
    //         text: 'show_bread',
    //         active: true,
    //       },
    //     );
    //   }
    //   next();
    // }
  },
  // {
  //   path: '/show-topic/:id',
  //   name: 'show_topic',
  //   component: () => import('@/views/modules/topics/ShowTopic.vue'),
  //   meta:{
  //     breadcrumb: [],
  //   },
  //   beforeEnter: (to, from, next) => {
  //     if (from.name) {
  //       to.meta.breadcrumb = [];
  //       if(from.query && from.query.module_id){
  //         to.meta.breadcrumb.push({
  //           text: 'Preview Module',
  //           href: `/learning/preview-module/${from.query.module_id}`
  //         });
  //       }else{
  //         to.meta.breadcrumb.push({
  //           text: 'Preview Module',
  //           href: from.path
  //         });
  //       }
  //       to.meta.breadcrumb.push({
  //         text: 'show_bread',
  //         active: true,
  //       });
  //     }
  //     else{
  //       to.meta.breadcrumb = [];
  //       to.meta.breadcrumb.push(
  //         {
  //           text: 'Topics',
  //           to: '/topics'
  //         },
  //         {
  //           text: 'show_bread',
  //           active: true,
  //         },
  //       );
  //     }
  //     next();
  //   }
  // },
]
